const CardData = [
  {
    id: 0,
    title: 'Раздел 1',
    desc: 'простые и самые распространенные слова',
    level: 'A1',
    path: '/textbook/0/0',
    isAuthReq: false,
  },
  {
    id: 1,
    title: 'Раздел 2',
    desc: 'слова для бытовых ситуаций, поддержания простого диалога',
    level: 'A2',
    path: '/textbook/1/0',
    isAuthReq: false,
  },
  {
    id: 2,
    title: 'Раздел 3',
    desc: 'слова для описания впечатлений, повседневных событий',
    level: 'B1',
    path: '/textbook/2/0',
    isAuthReq: false,
  },
  {
    id: 3,
    title: 'Раздел 4',
    desc: 'слова для общения как на повседневные, так и на сложные темы',
    level: 'B2',
    path: '/textbook/3/0',
    isAuthReq: false,
  },
  {
    id: 4,
    title: 'Раздел 5',
    desc: 'слова, позволяющие общаться на любые темы, в том числе научные',
    level: 'C1',
    path: '/textbook/4/0',
    isAuthReq: false,
  },
  {
    id: 5,
    title: 'Раздел 6',
    desc: 'слова на уровне носителей языка',
    level: 'C2',
    path: '/textbook/5/0',
    isAuthReq: false,
  },
  {
    id: 6,
    title: 'Сложные слова',
    desc: 'слова, отмеченные как сложные',
    level: '★',
    path: '/textbook/6/0',
    isAuthReq: true,
  },
];

export default CardData;
